import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import ErrorIcon from '@mui/icons-material/Error';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import {unzip} from 'unzipit';
import {Fraction} from 'opensheetmusicdisplay'; //OpenSheetMusicDisplay, TransposeCalculator, PointF2D, 
import './SheetMusicPlayerDebugPanel.css';
// import SoundFont from 'soundfont-player';
import midiParser  from 'midi-parser-js'; 
// import {WebMidi} from "webmidi";
import 'utils/WebBleMidiTransmitterPlugin'
import MidiPlayer  from 'midi.js';
import utils from 'utils/utils';
import ScoreDisplayer from 'ScoreDisplayer.js'
import settingSystem from "SettingSystem.js"
import SettingSystem from 'SettingSystem.js';
import Keyboard from 'components/Keyboard/Keyboard'
import axios from 'axios';
import cbor from 'cbor-js';
import {getColorFromRainbowPalette} from "../ColorHelper"
import Backdrop from '@mui/material/Backdrop';
import TextManager from 'TextManager';
// import MidiPlayer from 'midi-player-js';
const WebBleMidiInternalID = "WebBleMidi";
const WebAudioInternalID = "WebAudio";
const WebMidiInternalID = "WebMidi";

const excludedInst = [
  "pan_flute",
  "blown_bottle",
  "shakuhachi",
  "whistle",
  "ocarina",
  "lead_1_square",
  "lead_2_sawtooth",
  "lead_3_calliope",
  "lead_4_chiff",
  "lead_5_charang",
  "lead_6_voice",
  "lead_7_fifths",
  "lead_8_bass__lead",
  "pad_1_new_age",
  "pad_2_warm",
  "pad_3_polysynth",
  "pad_4_choir",
  "pad_5_bowed",
  "pad_6_metallic",
  "pad_7_halo",
  "pad_8_sweep",
  "fx_1_rain",
  "fx_2_soundtrack",
  "fx_3_crystal",
  "fx_4_atmosphere",
  "fx_5_brightness",
  "fx_6_goblins",
  "fx_7_echoes",
  "fx_8_scifi",
  "sitar",
  "banjo",
  "shamisen",
  "koto",
  "kalimba",
  "bagpipe",
  "fiddle",
  "shanai",
  "tinkle_bell",
  "agogo",
//   "steel_drums",
  "woodblock",
  "taiko_drum",
  "melodic_tom",
  "synth_drum",
  "reverse_cymbal",
  "guitar_fret_noise",
  "breath_noise",
  "seashore",
  "bird_tweet",
  "telephone_ring",
  "helicopter",
  "applause",
  "gunshot"
]

export default class SheetMusicPlayer extends React.Component {
	state = { 
		//debugVisible: false,
		data: null,
		result: "pending",
		imageFilesToUpload: null,
		mxlFileToUpload: null,
		mxl: null,
		midi: null,
		midiMeta: null,
		bpm: 120,

		transpose: 0,

		readyToPlay: false,
		isPlaying: false,

		currentTime: 0,
		endTime: 0,

		cursorTimesteps: [],
		currentCursorTimestep: 0,
		currentRepetition: {
			repetition: null,
			index: 0,
		},
		repetitions: [],

		selectedMidiOutputId: "",
		selectedMidiOutputMethod: WebAudioInternalID,

		bleConnecting: false,

		// webBleMidi: new WebBleMidiTransmitter(),
		channels: [],
		avaliableInstruments: [
			// {id: 'acoustic_grand_piano', name:'Piano'},
			// {id: 'accordion', name: "Accordion"},
			// {id: 'steel_drums', name: "Steel Drums"},
		],
	};

	constructor(props) {
		super(props);

		settingSystem.registerMember("playerTempo", this, "tempo");
		settingSystem.registerMember("playerTranspose", this, "transpose");

		settingSystem.registerMember("loopTimestamp", this, "loopTimestamp");
		SheetMusicPlayer.singleton = this;
	}

	WebBleMidiInternalID = WebBleMidiInternalID
	WebAudioInternalID = WebAudioInternalID
	WebMidiInternalID = WebMidiInternalID

	get avaliableMidiOuputs(){
		return MidiPlayer.WebMIDI.outputs;
	}

	set useMetronome(value){
		MidiPlayer.setUseMetronome(value);
	}

	get useMetronome(){
		return MidiPlayer.Player.useMetronome;
	}

	get tempo() {
		return this.state.bpm;
	}
	set tempo(v) {
		this.setBPM(v);
	}

	get transpose(){
		return this.state.transpose;
	}
	set transpose(v) {
		this.setTranspose(v);
	}

	get loopTimestamp() {
		if(MidiPlayer.Player.loopStart != null && MidiPlayer.Player.loopEnd  != null )
			return [this.getTimeStampFromPlaybackTime(MidiPlayer.Player.loopStart), this.getTimeStampFromPlaybackTime(MidiPlayer.Player.loopEnd)];

		return null;
	}

	set loopTimestamp(v) {
		if(v){
			const startPossibleTimes = this.getPossiblePlaybackTimeFromTimestamp(v[0]);
			const endPossibleTimes = this.getPossiblePlaybackTimeFromTimestamp(v[1]);
			let start = startPossibleTimes[startPossibleTimes.length - 1];
			let end = endPossibleTimes[0];
			for (const endTime of endPossibleTimes) {
				if(endTime > start){
					end = endTime;
					break;
				}
			}
			MidiPlayer.Player.setLoop(start, end);
		
		}
		else{
			MidiPlayer.Player.cancelLoop();
		}
	}

	async componentDidMount() {
		
		
		
		//console.log(SheetMusicPlayer.singleton)
		// this.setState({
		// 	osmd: ScoreDisplayer.singleton.osmd
		// 	// osmd: new OpenSheetMusicDisplay("osmdCanvas", {
		// 	// 	// set options here
		// 	// 	backend: "svg",
		// 	// 	drawFromMeasureNumber: 0,
		// 	// 	drawUpToMeasureNumber: Number.MAX_SAFE_INTEGER // draw all measures, up to the end of the sample
		// 	// })



		// });
		

		// document.addEventListener("keydown", e => {
		// 	if(e.key === '`'){
		// 		this.setState({
		// 			debugVisible: !this.state.debugVisible
		// 		})
		// 	}
		// });

		try {
			await this.initMidiPlayer();
			
		} catch (error) {
			this.setState({errorMessage: "Failed to initialize MIDI Player, audio playback may not be avaliable"})
			console.log("failed to initialize Web Midi: ", error)
		}
		


		// if(this.state.data){
		// 	this.loadData(this.state.data)
		// }
		
	}

	

	onImageFilesChanged = (event) => {
		// Update the state
		this.setState({ imageFilesToUpload: event.target.files});
	};

	onMxlFileChanged = (event) => {
		// Update the state
		//console.log(event);
		//console.log(event.target.files);
		this.setState({ mxlFileToUpload: event.target.files[0]});
	};

	clearData = () => {
		this.stop();
		this.setState({ 
			result: "pending",
			mxl: null,
			midi: null,
			midiMeta: null,
			bpm: 120,
			readyToPlay: false,
			isPlaying: false,
			currentTime: 0,
			endTime: 0,
		});
		this.updateSeekbarVisual()
		//ScoreDisplayer.singleton.osmd.clear();
	}

	onPlayButtonClicked = (event) => {
		// Update the state
		this.playOrPause();
	};

	playOrPause = (event) => {
		// Update the state
		//console.log("playOrPause", this.state.isPlaying);
		let isPlaying = !this.state.isPlaying;

		if(isPlaying){
			this.play();
		}
		else{
			this.pause();
		}


		return isPlaying
	};

	play = () => {
		if(!this.state.readyToPlay){
			return;
		}


		if(MidiPlayer.Player.currentTime >=  MidiPlayer.Player.endTime && !MidiPlayer.Player.isPlaying){
			MidiPlayer.Player.currentTime = 0;
		}
		// console.log(MidiPlayer.Player.currentTime);
		if(MidiPlayer.Player.currentTime <= 0){
			MidiPlayer.Player.start()
		}
		else{
			MidiPlayer.Player.resume()
		}
		

		//console.log(this)
		//this.midiPlayer.play();
		//console.log("start", this.state.isPlaying);
		this.setState({isPlaying: true});
		this.updateSeekbarVisual()
		//this.seekbarUpdateIntervalId = setInterval(this.updateSeekbar, 15);

		Keyboard.singleton.releaseAllNote();


		MidiPlayer.Player.clearAnimation(); // clears current animation.
		MidiPlayer.Player.setAnimation(this.handleMidiPlayerAnimationFrame);

		MidiPlayer.Player.removeListener(); // removes current listener.
		MidiPlayer.Player.addListener(this.handleMidiPlayerEvent);


		MidiPlayer.Player.removeOnLoopRestartedListener(); // removes current listener.
		MidiPlayer.Player.setOnLoopRestartedListener(this.handleLoopRestarted);

	}

	setKeyBoardActiveNotes(newActiveNotes){
		let notes = Keyboard.singleton.activeNotes.slice();
		//console.log(notes)
		for (const note of notes) {
			if(!newActiveNotes.find(n => n.note === note.note && n.track === note.track)){
				Keyboard.singleton.releaseNote(note.note, note.track);
			}
		}


		for (const note of newActiveNotes){
			if(!Keyboard.singleton.checkNoteActive(note.note, note.track)){
				Keyboard.singleton.playNote(note.note, note.track, this.getKeyboardColor(note.note, note.track))
			}
		}
	}

	

	getKeyboardColor(note, track){
		const mode = settingSystem.getSetting("noteColorMode");
		
		if (mode === 1) { // colored by note pitch
			const position = (note % 12) / 12;
			return getColorFromRainbowPalette(position);
		} else if (mode === 2) { // colored by track
			const position = (track - 1) / ScoreDisplayer.singleton.osmd.Sheet.Staves.length;
			return getColorFromRainbowPalette(position);
		} else { // reset
			return null;
		}
		
	}


	handleMidiPlayerAnimationFrame = (data) => {
		var now = MidiPlayer.Player.getDisplayedAudioContextPlaytime(); // where we are now
		var end = data.end; // time when song ends
		//var events = data.events; // all the notes currently being processed
		//console.log(MidiPlayer.Player.getDisplayedAudioContextPlaytime())
		this.setState({
			currentTime: now,
			endTime: end
		});




		//console.log(MidiPlayer.Player.getAudioContextPlaytime())
		this.updateCursorPositionByPlaybackTime(MidiPlayer.Player.getDisplayedAudioContextPlaytime(), false);
		// if(MidiPlayer.Player.getDisplayedAudioContextPlaytime() < this.lastDisplayedAudioContextPlaytime){
		// 	Keyboard.singleton.releaseAllNote();
		// }
		// this.lastDisplayedAudioContextPlaytime = MidiPlayer.Player.getDisplayedAudioContextPlaytime();
		//console.log(now, end);

		var activeNotes = MidiPlayer.getActiveNotes();
		this.setKeyBoardActiveNotes(activeNotes);

		if (MidiPlayer.Player.getDisplayedAudioContextPlaytime() >= end) {
			this.stop();
		}
		
		
	}

	handleMidiPlayerEvent = (data) => { // set it to your own function!
		// var now = data.now / 1000 / 4; // where we are now
		// var end = data.end; // time when song ends
		// var channel = data.channel; // channel note is playing on
		// var message = data.message; // 128 is noteOff, 144 is noteOn
		// var note = data.note; // the note
		// var velocity = data.velocity; // the velocity of the note
		// var raw = data.rawData; // the velocity of the note
		// then do whatever you want with the information!
		//console.log(raw);
		// if(message === 128){
		// 	console.log(note, velocity, message, now);
		// }
		// if(this.state.selectedMidiOutputId === WebBleMidiInternalID){
		// 	this.state.webBleMidi.sendMidiMessage(raw);
		// }
		// else{
		// 	this.state.selectedMidiOutput?.send(raw);
		// }
		//this.getCurrentplaybackTime();

		//console.trace()
	}

	handleLoopRestarted = ()=>{
		//Keyboard.singleton.releaseAllNote();
		// this.setState({
		// 	currentCursorTimestep: 0
		// });
		// ScoreDisplayer.singleton.osmd?.cursor?.resetIterator();
	}

	seekByTimestamp = (timestamp) => {
		const possibleTime = this.getPossiblePlaybackTimeFromTimestamp(timestamp);
		
		let timeToSeek = 0;
		for (const time of possibleTime) {
			const repetition = this.checkCurrentRepetition(time);
			//console.log(time, this.state.currentRepetition, repetition)
			if(this.state.currentRepetition === repetition){
				timeToSeek = possibleTime[repetition === null ? 0 : 1];
			}
			else{
				timeToSeek = possibleTime[0];
			}
		}
		
		//console.log(timestamp, possibleTime, timeToSeek);
		//console.log(timestamp, timeToSeek);
		//console.log(entry.sourceStaffEntry, timestamp );//time
		this.seek(timeToSeek)
	}

	seek = (targetTime) => {
		var originallyIsPlaying = MidiPlayer.Player.playing;
		MidiPlayer.Player.pause()
		//console.log(targetTime, MidiPlayer.Player.currentTime, targetTime * 1000)
		MidiPlayer.Player.currentTime = targetTime * 1000;
		this.updateSeekbarVisual()

		if(originallyIsPlaying){
			this.play();
		}
		else{
			this.setKeyBoardActiveNoteByCursorHover();
		}
	}

	updateSeekbarVisual = () => {
		this.setState({
			currentTime: this.getCurrentplaybackTime(),
			endTime: MidiPlayer.Player.endTime / 1000,
		})
		this.updateCursorPositionByPlaybackTime(this.getCurrentplaybackTime(), true);
	}

	pause = () => {
		MidiPlayer.Player.pause();
		//this.midiPlayer.pause()
		//console.log("pause", this.state.isPlaying);
		this.setState({isPlaying: false});


		MidiPlayer.Player.clearAnimation(); // clears current animation.
		MidiPlayer.Player.removeListener(); // removes current listener.
		MidiPlayer.Player.removeOnLoopRestartedListener(); // removes current listener.
		Keyboard.singleton.releaseAllNote();
		this.setKeyBoardActiveNoteByCursorHover();
	}



	stop = () => {
		//console.log("stop");
		MidiPlayer.Player.stop();
		this.setState({isPlaying: false});
		//clearInterval(this.seekbarUpdateIntervalId);
		this.updateSeekbarVisual();
		
		MidiPlayer.Player.clearAnimation(); // clears current animation.
		MidiPlayer.Player.removeListener(); // removes current listener.
		MidiPlayer.Player.removeOnLoopRestartedListener(); // removes current listener.
		Keyboard.singleton.releaseAllNote();
		this.setKeyBoardActiveNoteByCursorHover();
	}

	onSeekbarChanged = (event) => {
		this.seek(event.target.value);
	}

	setKeyBoardActiveNoteByCursorHover() {
	
		if(! ScoreDisplayer.singleton.osmd || ! ScoreDisplayer.singleton.osmd.cursor){
			Keyboard.singleton.releaseAllNote();
			return;
		}
		var notes = ScoreDisplayer.singleton.osmd.cursor.NotesUnderCursor();
		var activeNotes = [];


		for (let note of notes) {
			//console.log(note, note.TransposedPitch, note.Pitch)
			if (note && (note.TransposedPitch || note.Pitch)) {
				//let track = note.ParentStaff.ParentInstrument.Id;
				let track = note.ParentStaff.id;


				activeNotes.push({
					note: (note.TransposedPitch || note.Pitch).getHalfTone() + 12,
					track: track,
				});
			}
		}
		// console.log(activeNotes)
		this.setKeyBoardActiveNotes(activeNotes);
	}

	getCurrentplaybackTime() {
		return MidiPlayer.Player.currentTime / 1000;
	}

	async loadData(data, isSample=false) {
		//console.log(data);
		this.clearData();
		this.setState({ 
			data: data,
			result: data.message
		});

		//Load music XML
		await this.loadMusicXml(data);
		
		//Load MIDI
		await this.loadMidi(data);

		this.updateSeekbarVisual();
		this.setState({ readyToPlay: true });
		//console.log("123")

		if (!isSample) {
			this.props.onNonSampleScoreLoaded();
		}

		
	}

	async loadMusicXml(data) {
		this.setState({mxl: data.mxl})
		let xmlBuffer;
		try {
			const { entries } = await unzip(data.mxl);
			//console.log(entries);
			xmlBuffer = await entries[Object.keys(entries).find(k => (k.includes(".xml") || k.includes(".musicxml")) && ! k.includes("META-INF"))].arrayBuffer();
			// if(xmlBuffer == null){
			// 	//console.log(entries[Object.keys(entries).find(k => k.includes(".musicxml") && ! k.includes("META-INF"))])
			// 	xmlBuffer = await entries[Object.keys(entries).find(k => k.includes(".musicxml") && ! k.includes("META-INF"))].arrayBuffer();
			// }
		}
		catch(exception){
			xmlBuffer = data.mxl
		}
		
		const enc = new TextDecoder("utf-8");
		const xmlContent = enc.decode(xmlBuffer);

		
		// let parser = new DOMParser();
		// let xmlDoc = parser.parseFromString(xmlContent,"text/xml");
		// let stack = [xmlDoc.documentElement]
		// while (stack.length > 0) { //dfs
		// 	const currentNode = stack.pop();
		// 	//console.log(currentNode, currentNode.childNodes)
		// 	let i = 0;
		// 	while (i < currentNode.childNodes.length) {
		// 		const node = currentNode.childNodes[i];
		// 		if(currentNode.nodeName === "rest"){ //elements inside <rest/> cause cursor to be misaligned and NoteUnderCursor to detect unwanted notes
		// 			currentNode.removeChild(node);
		// 		}
		// 		else if(node.nodeName === "words"){  //empty words in the tempo marking cause OSMD to unable to load score
		// 			currentNode.removeChild(node);
		// 		}
		// 		else if(node.nodeName === "credit"){  //empty words in the tempo marking cause OSMD to unable to load score
		// 			currentNode.removeChild(node);
		// 		}
		// 		else if(node.nodeName === "creator"){  //empty words in the tempo marking cause OSMD to unable to load score
		// 			currentNode.removeChild(node);
		// 		}
		// 		else if(node.data === "[Audiveris detected movement]"){  //empty words in the tempo marking cause OSMD to unable to load score
		// 			node.data = "Scanned Score"
		// 		}
		// 		else{
		// 			stack.push(node)
		// 			i++;
		// 		}
		// 	}
		// }

		// let  processedXml = new XMLSerializer().serializeToString(xmlDoc)
		// //console.log(processedXml)
		// //processedXml = processedXml.replace("<words></words>", ""); //TODO: proper parsing xml and removing problematic entries
		// //processedXml = processedXml.replace('<!DOCTYPE score-partwise  PUBLIC "-//Recordare//DTD MusicXML 3.1 Partwise//EN" "http://www.musicxml.org/dtds/partwise.dtd">', ""); //TODO: proper parsing xml and removing problematic entries
		// //processedXml = processedXml.replace(/<rest .* <\/rest>/, "<rest/>")
		// //console.log(data.mxl, xmlContent, processedXml)
		await ScoreDisplayer.singleton.osmdLoadXML(xmlContent);

		//for synchronising cursor
		this.storeCursorTimesteps();

		
	}

	storeCursorTimesteps() {
		let timestamps = [];
		let musicPartIterator = ScoreDisplayer.singleton.osmd.sheet.musicPartManager.getIterator();
		while (!musicPartIterator.EndReached) {
			timestamps.push({
				timestamp: musicPartIterator.currentTimeStamp,
				voiceEntry: musicPartIterator.currentTimeStamp
			});
			musicPartIterator.moveToNext();
		}
		//console.log(timestamps);
		this.setState({
			cursorTimesteps: timestamps,
			currentCursorTimestep: 0
		});



		//console.log(timestamps);
	}

	async loadMidi(data) {
		this.setState({ 
			midi: data.midi,
			midiMeta: data.meta,
			bpm: data.meta.bpm,
		});

		settingSystem.setSetting("displayTempo",data.meta.bpm, this);

		//console.log(data.meta);

		let parsedMidi = midiParser.parse(data.midi);
		
		//console.log(parsedMidi, MidiPlayer.GM);
		MidiPlayer.Player.TimeSignitures = data.meta.timeSignatures; //timesigniture need to be loaded before main midi data to get it to work
		MidiPlayer.Player.Measures = data.meta.measures; //timesigniture need to be loaded before main midi data to get it to work
		MidiPlayer.Player.BPM = data.meta.bpm;
		await this.loadMidiData(data.midi);
		
		MidiPlayer.Player.OverrideProgramChanges = true;
		MidiPlayer.MidiChannelMapping = {0:0, 1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0}

		let instruments = [];
		let channels = [];
		for (let index = 0; index < 16; index++) {
			let instrumentName = 'acoustic_grand_piano';
			channels.push(
				{
					id: index,
					instrument: instrumentName,
					muted: false,
					solo: false,
					haveNotes: false,
				}
			);
			MidiPlayer.setInstrument(index, MidiPlayer.GM.byName[instrumentName].number);
		}

		instruments.push('acoustic_grand_piano', 'steel_drums');

		for (const track of parsedMidi.track) {
			for (const event of track.event) {
				if(event.channel !== undefined){
					channels[event.channel].haveNotes = true;
					if(event.type === 0x0c){
						const inst = MidiPlayer.GM.byId[event.data];
						MidiPlayer.setInstrument(event.channel, inst.number);
						channels[event.channel].instrument = inst.id;
						instruments.push(inst.id);
					}
				}
			}
		}

		await MidiPlayer.loadPlugin({
			soundfontUrl: "https://gleitz.github.io/midi-js-soundfonts/FluidR3_GM/",
			instruments: instruments
		})

		this.setState({ 
			channels: channels,
		});

		//this.setBPM(data.meta.bpm)
	}

	initMidiPlayer = async ()=>{
		var avaliabelInst = [];
		let instrumentsToLoad = [];

		//var instTranslation = {};

		for (const instName in MidiPlayer.GM.byName) {
			if(excludedInst.contains(instName)){
				continue;
			}
			let inst = MidiPlayer.GM.byName[instName]
			avaliabelInst.push({
				category: inst.category,
				id: inst.id,
				name: inst.instrument,
				number: inst.number
			});
			instrumentsToLoad.push(inst.id)

			//instTranslation[inst.id] = [inst.instrument, "_", "_"]
		}

		//console.log(JSON.stringify(instTranslation));

		this.setState({avaliableInstruments: avaliabelInst})
			
		MidiPlayer.WebMIDI.setStateChangeEventListener(this.updateMidiOutputList);

		await MidiPlayer.loadPlugin({
			soundfontUrl: "https://gleitz.github.io/midi-js-soundfonts/FluidR3_GM/",
			//instruments: instrumentsToLoad
		})

		MidiPlayer.API["BleMIDI"].api.transmitter.setDisconnectedCallback(this.onBleMidiDisconnected);

		SettingSystem.registerMember("useMetronome", this, "useMetronome");

		//console.log(SettingSystem.getSetting("useMetronome"));
	}

	updateMidiOutputList = (event) => {
		//console.log(MidiPlayer,  MidiPlayer.WebMIDI, MidiPlayer.WebMIDI.outputs);
		if(!MidiPlayer.WebMIDI.outputs.find(d => d.id === this.state.selectedMidiOutputId)){
			if(MidiPlayer.WebMIDI.outputs[0]){
				this.setMidiOutputDevice(MidiPlayer.WebMIDI.outputs[0].id);
			}
			else{
				this.setMidiOutputDevice('');
			}
		}
		else{
			this.setMidiOutputDevice(this.state.selectedMidiOutputId);
		}

		this.props.onUpdateMidiOutputList?.call(this);
	}

	seekPreviousTimestep = () => {
		let timestepIndex = this.state.currentCursorTimestep - 1;
		if(timestepIndex <= 0){
			timestepIndex = 0;
		}
		const timestamp = this.state.cursorTimesteps[timestepIndex].timestamp.realValue;
		this.seekByTimestamp(timestamp);
	}

	seekNextTimestep = () => {
		let timestepIndex = this.state.currentCursorTimestep + 1;
		if(timestepIndex >= this.state.cursorTimesteps.length){
			timestepIndex = this.state.cursorTimesteps.length - 1;
		}
		const timestamp = this.state.cursorTimesteps[timestepIndex].timestamp.realValue;
		this.seekByTimestamp(timestamp);
	}

	seekPreviousMeasure = () => {
		let timestepIndex = this.state.currentCursorTimestep;
		const timestamp = this.state.cursorTimesteps[timestepIndex].timestamp.realValue;
		if(this.state.midiMeta.measures.length > 0){
			var lastMeasure = this.state.midiMeta.measures[0]
			for (const measureStart of this.state.midiMeta.measures) {
				const measureStartTimestamp = measureStart;
				//console.log(measureStart, measureStartTimestamp, timestamp)
				if(measureStartTimestamp >= timestamp){
					break;
				}
				lastMeasure = measureStart;
			}
			this.seekByTimestamp(lastMeasure);
		}
	}

	seekNextMeasure = () => {
		let timestepIndex = this.state.currentCursorTimestep;
		const timestamp = this.state.cursorTimesteps[timestepIndex].timestamp.realValue;
		
		if(this.state.midiMeta.measuresIgnoreRepetitions.length > 0){
			for (const measureStart of this.state.midiMeta.measuresIgnoreRepetitions) {
				const measureStartTimestamp = measureStart;
				//console.log(measureStart, measureStartTimestamp, timestamp)
				if(measureStartTimestamp > timestamp){
					this.seekByTimestamp(measureStart);
					break;
				}
			}
		}
	}

	updateCursorPositionByPlaybackTime = (currentPlaybackTime, isSeeking) => {
		//console.log("===============", this.state.readyToPlay, "=============");
		if(!this.state.readyToPlay){
			return;


		}

		const newRepetition = this.checkCurrentRepetition(currentPlaybackTime);
		const needRecalculation = (newRepetition !== this.state.currentRepetition);
		
		
		//console.log(updatedTimeStep, isSeeking, needRecalculation, newRepetition, this.state.currentRepetition)
		// console.log(this, currentPlaybackTime, this.state.currentTime)
		let updatedTimeStep = this.state.currentCursorTimestep;
		if(isSeeking || needRecalculation || currentPlaybackTime < this.state.currentTime){
			updatedTimeStep = 0;
			ScoreDisplayer.singleton.osmd?.cursor?.resetIterator();
		}


	// //ScoreDisplayer.singleton.osmd?.cursor?.resetIterator(); 
	// const currentTime = ScoreDisplayer.singleton.osmd.cursor.Iterator.currentTimeStamp.realValue;
	// const timestampFromPlayback = this.getTimeStampFromPlaybackTime(currentPlaybackTime);
	// console.log(currentTime, timestampFromPlayback);



		const timestampFromPlayback = this.getTimeStampFromPlaybackTime(currentPlaybackTime);

		
		//console.log(this.state.cursorTimesteps)



		for (let index = updatedTimeStep + 1; index < this.state.cursorTimesteps.length; index++) {
			const timestamp = this.state.cursorTimesteps[index].timestamp.realValue;
			//console.log(index);

			//console.log(timestamp, timestampFromPlayback);
			
			if (timestampFromPlayback >= timestamp ) {
				ScoreDisplayer.singleton.osmd.cursor.Iterator.moveToNext();
				updatedTimeStep++;
			}
			else{
				break;
			}
		}

		//console.log(this.osmd);
		//console.log(currentPlaybackTime, timestampFromPlayback, updatedTimeStep);

		if(updatedTimeStep !== this.state.currentCursorTimestep){
			//console.log(updatedTimeStep, this.state.currentCursorTimestep);
			ScoreDisplayer.singleton.osmd.cursor.update();
			// ScoreDisplayer.singleton.osmd.cursor.previous();
			// ScoreDisplayer.singleton.osmd.cursor.next();
		}
		//console.log(currentPlaybackTime, updatedTimeStep, timestampFromPlayback);

		this.setState({ 
			currentCursorTimestep: updatedTimeStep ,
			currentRepetition: newRepetition,
		});
	}

	getTimeStampFromTimestampThatIgnoreRepetitions = (timestamp) => {
		for (const repetition of this.state.midiMeta.repetitions) {
			const repeitionDuration =  repetition.end - repetition.start;
			//console.log(timestamp, repetition.end, repeitionDuration);
			if(timestamp > repetition.end){
				timestamp -= repeitionDuration
			}
		}
		
		//console.log("return", timestamp);
		return timestamp;
	}

	getTimeStampFromPlaybackTime = (playbackTime) => {
		let timestamp = this.getTimeStampFromPlaybackTimeIgnoreRepetition(playbackTime)
		return this.getTimeStampFromTimestampThatIgnoreRepetitions(timestamp)
	}

	getTimeStampFromPlaybackTimeIgnoreRepetition = (playbackTime) => {
		if(playbackTime.realValue !== undefined){
			playbackTime = playbackTime.realValue;
		}
		return playbackTime * this.state.bpm / 60 / 4;
	}

	checkCurrentRepetition = (playbackTime)=> {
		//let count = 0;

		var timestamp = this.getTimeStampFromPlaybackTimeIgnoreRepetition(playbackTime)

		for (let i = 0; i < this.state.midiMeta.repetitions.length; i++) {
			const repetition = this.state.midiMeta.repetitions[i];
			const start = repetition.start;
			const end = repetition.end;
			const repeitionDuration =  end - start;
			//console.log(timestamp, end, repeitionDuration);
			if(timestamp > end){
				timestamp -= repeitionDuration
				//console.log(timestamp);
				if(timestamp < end){
					//count++;

					return repetition;
				}
			}
		}

		return null;
	}



	async loadMidiData(midi) {
		var base64 = "data:audio/midi;base64," + utils.arrayBufferToBase64(midi);
		await MidiPlayer.Player.loadFile(base64);

		
	}

	getPossiblePlaybackTimeFromTimestamp(timestamp) {
		var rawPlaybackTime = this.getPlaybackTimeFromTimestampIgnoreRepetition(timestamp);
		var playbackTime = [rawPlaybackTime];
		for (const repetition of this.state.midiMeta.repetitions) {
			const start = this.getPlaybackTimeFromTimestampIgnoreRepetition(repetition.start);
			const end = this.getPlaybackTimeFromTimestampIgnoreRepetition(repetition.end);

			const repeitionDuration = end - start;

			if(rawPlaybackTime > end){
				for (let i = 0; i < playbackTime.length; i++) {
					playbackTime[i] += repeitionDuration;
				}
			}
			else if (rawPlaybackTime >= start){
				playbackTime.push(playbackTime[playbackTime.length - 1] + repeitionDuration)
			}
			
		}
		//console.log(rawPlaybackTime, playbackTime);
		return playbackTime;
	}

	getPlaybackTimeFromTimestampIgnoreRepetition(timestamp) {
		if(timestamp instanceof Fraction){
			timestamp =  timestamp.realValue
		}
		return timestamp / this.state.bpm * 60 * 4;
	}



	toTimeString(ms){
		try {
			return new Date(ms * 1000).toISOString().slice(14, -2)
		} catch (error) {
			console.log(`cannot convert time string from ${ms}`, error)
			return "";
		}
		
	}



	// onSheetMusicClicked = (event) => {
	// 	if(ScoreDisplayer.singleton.osmd && ScoreDisplayer.singleton.osmd.graphic){
	// 		let position = this.getOSMDCoordinates(new PointF2D(event.clientX, event.clientY));//getOSMDCoordinates
			
	// 		let timestamp = ScoreDisplayer.singleton.osmd.graphic.tryGetTimeStampFromPosition(position);
	// 		if(timestamp != null){
	// 			console.log(timestamp)
	// 			this.seekByTimestamp(timestamp)
	// 		}
	// 	}
	// }

	// getOSMDCoordinates(clickLocation) {
    //     const sheetX = (clickLocation.x - ScoreDisplayer.singleton.osmd.container.offsetLeft + ScoreDisplayer.singleton.osmd.container.scrollLeft) / 10;
    //     const sheetY = (clickLocation.y - ScoreDisplayer.singleton.osmd.container.offsetTop + ScoreDisplayer.singleton.osmd.container.scrollTop) / 10;
    //     return new PointF2D(sheetX, sheetY);
    // }

	setMidiOutputMethod = async(deviceID) =>{
		this.pause();
		if(deviceID === WebBleMidiInternalID){
			this.setState({
				selectedMidiOutputMethod: WebBleMidiInternalID
			});
			this.setState({
				bleConnecting: true
			});
			
			let connectionSuccessful = await MidiPlayer.API["BleMIDI"].api.userConnect()

			this.setState({
				bleConnecting: false
			});
			if(connectionSuccessful){
				MidiPlayer.API.BleMIDI.enabled = true;
				MidiPlayer.API.WebMIDI.enabled = false;
				MidiPlayer.API.WebAudio.enabled = false;
				return;
			}
			else{
				this.setState({errorMessage: TextManager.getText("bluetooth_midi_initialization_failed")})
			}
		}
		else if(deviceID === WebMidiInternalID){
			this.setState({
				selectedMidiOutputMethod: WebMidiInternalID
			});

			let connectionSuccessful = await MidiPlayer.API["WebMIDI"].api.userConnect()

			if(connectionSuccessful){
				this.updateMidiOutputList()

				//console.log(MidiPlayer.WebMIDI.outputs, this.state.selectedMidiOutputId)

				if(!MidiPlayer.WebMIDI.outputs.find(d => d.id === this.state.selectedMidiOutputId)){
					if(MidiPlayer.WebMIDI.outputs[0]){
						this.setMidiOutputDevice(MidiPlayer.WebMIDI.outputs[0].id);
					}
					else{
						this.setMidiOutputDevice('');
					}
				}
				else{
					this.setMidiOutputDevice(this.state.selectedMidiOutputId);
				}

				MidiPlayer.API.BleMIDI.enabled = false;
				MidiPlayer.API.WebMIDI.enabled = true;
				MidiPlayer.API.WebAudio.enabled = false;
				return;
			}
			else{
				this.setState({errorMessage: TextManager.getText("midi_device_initialization_failed")})
				//this.setState({errorMessage: "Failed initialize Web MIDI."})
			}

			
		}

		
		this.setState({
			selectedMidiOutputMethod: WebAudioInternalID
		});
		MidiPlayer.API["BleMIDI"].api.userDisconnect()
		MidiPlayer.API.BleMIDI.enabled = false;
		MidiPlayer.API.WebMIDI.enabled = false;
		MidiPlayer.API.WebAudio.enabled = true;
	}

	setMidiOutputDevice = async(deviceID) =>{
		if(MidiPlayer.WebMIDI.outputs.find(d => d.id === deviceID)){
			if(deviceID !== this.state.selectedMidiOutputId){
				this.pause();
			}
			this.setState({
				selectedMidiOutputId: deviceID
			});
			MidiPlayer.WebMIDI.setOutput(deviceID);
		}
		else{
			this.pause();
			this.setState({
				selectedMidiOutputId: 'noDevice'
			});
			MidiPlayer.WebMIDI.setOutput('');
		}
	}

	onBleMidiDisconnected = () =>{
		if(this.selectedMidiOutputMethod === WebBleMidiInternalID){
			this.setMidiOutputMethod(WebAudioInternalID)
		}
	}

	setTranspose = (newTranspose) =>{
		this.setState({
			transpose: newTranspose
		});


		MidiPlayer.Player.MIDIOffset = newTranspose;
		
		if(MidiPlayer.Player.playing){
			MidiPlayer.Player.pause()
			this.play();
		}
	}

	 onBpmChanged = async (event) =>{
		const newBpm = Math.max(Math.min(parseInt(event.target.value) ?? 120, 999), 1 );

		await this.setBPM(newBpm);

	}

	setInstrument = async (channel, instrumentName) =>{
		channel.instrument = instrumentName;
		this.setState({
			channels: this.state.channels,
			//readyToPlay: false,
		});
		//console.log(channel, channel.id, instrumentName);
		MidiPlayer.setInstrument(channel.id, MidiPlayer.GM.byName[instrumentName].number);

		

		// let instruments = [];
		// for (const channel of this.state.channels) {
		// 	console.log(channel);
		// 	instruments.push(channel.instrument);
		// }
		const originallyIsPlaying = MidiPlayer.Player.playing;
		this.pause();

		await MidiPlayer.loadPlugin({
			soundfontUrl: "https://gleitz.github.io/midi-js-soundfonts/FluidR3_GM/",
			instruments: [instrumentName]
		})

		if(originallyIsPlaying){
			this.play();
		}

		// await this.loadInstruments(instruments);

		// await this.loadMidiData(this.state.midi);

		// this.setState({
		// 	readyToPlay: true,
		// });
	}

	setChannelMute = async (channel, isMuted) =>{
		channel.mute = isMuted;
		this.setState({
			channels: this.state.channels,
		});
		console.log(channel.id, isMuted);
		MidiPlayer.setChannelMute(channel.id, isMuted);

		const originallyIsPlaying = MidiPlayer.Player.playing;
		this.pause();
		if(originallyIsPlaying){
			this.play();
		}
	}

	componentDidUpdate = (prevProps, prevState, snapshot)=>{
		if(prevState.isPlaying !== this.state.isPlaying){
			this.props.onPlayingStateUpdated?.call(this, this.state.isPlaying);
		}
	}

	async setBPM(newBpm) {
		this.setState({
			bpm: newBpm,
			readyToPlay: false,
		});

		const oldBPM = MidiPlayer.Player.BPM
		MidiPlayer.Player.BPM = newBpm;

		const originallyIsPlaying = MidiPlayer.Player.playing;
		const originallyIsPlayingIsReadyToPlay = this.state.readyToPlay;

		if (originallyIsPlaying) {
			MidiPlayer.Player.pause();
		}

		const timestamp = this.getTimeStampFromPlaybackTimeIgnoreRepetition(this.getCurrentplaybackTime());

		await this.loadMidiData(this.state.midi);

		if(this.loopTimestamp){
			this.loopTimestamp = [this.loopTimestamp[0] * oldBPM / newBpm,  this.loopTimestamp[1] * oldBPM / newBpm]
		}

		this.setState(
			{
				readyToPlay: originallyIsPlayingIsReadyToPlay
			},
			() => {
				console.log(this.getPlaybackTimeFromTimestampIgnoreRepetition(timestamp));
				this.seek(this.getPlaybackTimeFromTimestampIgnoreRepetition(timestamp));

				if (originallyIsPlaying) {
					this.play();
				}
			}
		);
	}

	sendTestRequest = async() => {
		SheetMusicPlayer.singleton.stop();
		this.setState({
			showProcessingDialog: true
		});

		try {
			const res =  await axios.post(`/api/test-omr`, {}, 
				{ 
					headers: { 'content-type': 'multipart/form-data' },
					responseType: 'arraybuffer'
				}
			);
			let data = cbor.decode(res.data);
			await SheetMusicPlayer.singleton.loadData(data);

		} catch (error) {
			this.setState({errorMessage: "Failed send test request"})
			console.log(error)
		} finally {
			this.setState({
				showProcessingDialog: false
			});
		}
	};

	render() {
		if(this.state.debugVisible){
			return (
				<div className="playback-controls">
					<button className="play" disabled={!this.state.readyToPlay} onClick={this.onPlayButtonClicked}>
						{this.state.isPlaying ? "Pause" : "Play"}
					</button>
					<button className="stop" onClick={this.stop}>
						Stop
					</button>
					<div className="time-label">
						<span className="current-time" >{this.toTimeString(this.state.currentTime)}</span> / <span className="total-time">{this.toTimeString(this.state.endTime)}</span>
					</div>
					<input type="range" value={this.state.currentTime} min="0" max={this.state.endTime} step="0.05" className="seek-bar" onChange={this.onSeekbarChanged}/>
					<div className="overlay loading-overlay" part="loading-overlay"></div>
					<div className='w-100'></div>
					<div><input type="file" name="sheets" multiple="multiple"  onChange={this.onImageFilesChanged}/> </div>
					<div><button onClick={this.sendProcessImageRequest}> Process images </button></div>
					<div><button onClick={this.sendProcessPdfRequest}> Process PDF </button></div>
					{/* <input type="file" name="mxl" onChange={this.onMxlFileChanged}/>
					<div><button onClick={this.sendProcessMxlRequest}> Process MXL </button></div> */}
					<div><button onClick={this.sendTestRequest}> Test </button></div>
					<div>
						<select
							value={this.state.selectedMidiOutputId} // ...force the select's value to match the state variable...
							onChange={  e => {this.setMidiOutputMethod(e.target.value)}} // ... and update the state variable on any change!
						>
							<option value={WebAudioInternalID}>-Select Midi Output- </option>
							{
								this.avaliableMidiOuputs.map((device) =>	<option key={device.id} value={device.id}>{device.manufacturer} {device.name}</option>)
							}
							<option value={WebBleMidiInternalID}>Use Bluetooth</option>
							<option value={WebBleMidiInternalID}>Use Bluetooth</option>
						</select>
					</div>
					{/* <div className='w-100'></div> */}
					<div>
						<label>transpose: </label>
						<input type="number" value={this.state.transpose} name="transpose" max="+24" min="-24" onChange={
							e => {
								var transpose = parseInt(e.target.value);
								SheetMusicPlayer.singleton.setTranspose(transpose);
								ScoreDisplayer.singleton.setTranspose(transpose);
							}
						}/> 
					</div>
					<div>
						<label>bpm: </label>
						<input type="number" value={this.state.bpm} max="999" min="1" name="bpm" onChange={this.onBpmChanged}/> 
					</div>

					<div className='w-100'></div>
					<div>
						{
							this.state.channels.filter(channel => channel.haveNotes).map((channel) =>
								<div key={channel.id}>
									<label>channel {channel.id}: </label>
									<select
										value={channel.instrument} // ...force the select's value to match the state variable...
										onChange={  e => {this.setInstrument(channel, e.target.value)}} // ... and update the state variable on any change!
									>
										{
											this.state.avaliableInstruments.map((inst) => 
												<option key={inst.id} value={inst.id}>{inst.id}</option>
											)
										}
									</select>
								</div>
							)
						}
					</div>
					<div className='w-100'></div>
					<div>{this.state.result}</div>
					{/* <div id="osmdCanvas" className="osmdCanvas" onClick={this.onSheetMusicClicked}/> */}
					<Dialog open={this.state.errorMessage != null} >
						<Box sx={{
							margin: "50px 50px",
						}}>
							<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
								<ErrorIcon />
								<Typography>{this.state.errorMessage}</Typography>
								<Button onClick={()=> this.setState({errorMessage: null})} variant="contained">{TextManager.getText("close")}</Button>
							</Stack>
						</Box>
					</Dialog>
				</div>

			);
		}
		else{
			return	<Box>
				<Dialog open={this.state.errorMessage != null} >
					<Box sx={{
						margin: "50px 50px",
					}}>
						<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
							<ErrorIcon />
							<Typography>{this.state.errorMessage}</Typography>
							<Button onClick={()=> this.setState({errorMessage: null})} variant="contained">{TextManager.getText("close")}</Button>
						</Stack>
					</Box>
				</Dialog>
				<Backdrop
					sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={this.state.bleConnecting}
				>
				</Backdrop>
			</Box>
			
		}
	}
}
